import { render, staticRenderFns } from "./oeb-menu.vue?vue&type=template&id=2e903271&scoped=true"
import script from "./oeb-menu.vue?vue&type=script&lang=js"
export * from "./oeb-menu.vue?vue&type=script&lang=js"
import style0 from "./oeb-menu.vue?vue&type=style&index=0&id=2e903271&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e903271",
  null
  
)

export default component.exports